import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control} from 'react-hook-form';

import {ColorPicker} from 'shells/color-picker/color-picker';
import {FormField} from 'shells/form/form-field';
import {TextField} from 'shells/textfield/textfield';

import {
    confineValueToRange,
    getBorderColorFromBorder,
    updateBorderColorForBorder,
} from '../../../../helpers';

import styles from '../design-form.module.css';

type Props = {
    control: Control;
    name: string;
};

export function TextfieldDesignForm(props: Props) {
    return (
        <>
            <FormField innerId='color' label='Color'>
                <Controller
                    name={'inputStyle.color'}
                    control={props.control}
                    // @ts-expect-error
                    render={({field}) => (
                        <ColorPicker
                            currentColor={field.value}
                            onSetCurrentColor={field.onChange}
                        />
                    )}
                />
            </FormField>
            <Controller
                name={'inputStyle.fontSize'}
                control={props.control}
                rules={{
                    required: true,
                    min: {
                        value: 8,
                        message: 'Fields can’t have a font size smaller than 8px',
                    },
                    max: {
                        value: 32,
                        message: 'Fields can’t have a font size larger than 32px',
                    },
                }}
                // @ts-expect-error
                render={({field, fieldState}) => {
                    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

                    return (
                        <FormField innerId='fontSize' label='Font size' errorMessage={errorMessage}>
                            <div className={styles['number-with-unit']}>
                                <TextField
                                    {...field}
                                    inputUnit='px'
                                    type='number'
                                    selectOnFocus={true}
                                    onBlur={() => {
                                        field.onChange(confineValueToRange(field.value, 8, 32, 16));
                                    }}
                                />
                            </div>
                        </FormField>
                    );
                }}
            />
            <FormField innerId='border' label='Outline color'>
                <Controller
                    name={'inputStyle.border'}
                    control={props.control}
                    // @ts-expect-error
                    render={({field}) => (
                        <ColorPicker
                            currentColor={getBorderColorFromBorder(field.value)}
                            onSetCurrentColor={(color) => {
                                field.onChange(updateBorderColorForBorder(field.value, color));
                            }}
                        />
                    )}
                />
            </FormField>
            <Controller
                name={'inputStyle.borderRadius'}
                control={props.control}
                rules={{
                    required: true,
                    min: {
                        value: 0,
                        message: 'Fields can’t have a negative border radius',
                    },
                    max: {
                        value: 16,
                        message: 'Fields can’t have a border radius larger than 16',
                    },
                }}
                // @ts-expect-error
                render={({field, fieldState}) => {
                    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

                    return (
                        <FormField
                            innerId='borderRadius'
                            label='Border radius'
                            errorMessage={errorMessage}
                            // Last field needs no bottom margin
                            noMargin={true}
                        >
                            <div className={styles['number-with-unit']}>
                                <TextField
                                    {...field}
                                    type='number'
                                    selectOnFocus={true}
                                    inputUnit='px'
                                    onBlur={() => {
                                        field.onChange(confineValueToRange(field.value, 0, 16, 3));
                                    }}
                                />
                            </div>{' '}
                        </FormField>
                    );
                }}
            />
        </>
    );
}
